import ApiURL from "./ApiURL";
import axios from "../axios";
import {
  setAccessTokenRespone,
  SetCarouselDataApiResponse,
  SetLiveAndUpcomingApiResponse,
  SetActivityInfoApiResponse,
  SetActivitySummaryApiResponse,
  SetCoachDataApiResponse,
  SetCoachProfileApiResponse,
  setLocation,
  SetListMyActivitiesApiRespnse,
  SetCategoriesApiResponse,
  SetCategoryProfileApiResponse,
  SetDashboardActivitiesApiResponse,
} from "./SetApiResponse";
import { UniqueID } from "./CommonFunction";
import { getAppIDFromURL } from "./Constants";
import { async } from "rxjs";
// import { profileActions } from "../store";

export const PostMethod = (url, data) => {
  return axios.post(ApiURL[url], data);
};

export const logoutUser = async () => {
  try {
    const response = await axios.post(ApiURL._logout, {});
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const loginSignup = async (formValue, status, headers) => {
  try {
    const data = {
      device_type: "WEB",
      app_version: "0",
      timezone_offset: "0",
      device_id: (+new Date()).toString() + UniqueID(),
      device_token: "0",
    };
    const response = await axios.post(
      ApiURL[`_${status}`],
      {
        ...data,
        ...formValue,
      },
      { headers: headers }
    );
    localStorage.setItem("accessToken", response.data.data.access_token);
    localStorage.setItem("setId", data.device_id);
    const updatedData = setAccessTokenRespone(response.data.data);
    return { data: updatedData, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const updateProfile = async (formdata) => {
  try {
    const response = await axios.post(ApiURL._updateProfile, formdata);
    const updatedData = setAccessTokenRespone(response.data.data);
    return { data: updatedData, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const forgotPassword = async (formdata) => {
  try {
    const response = await axios.post(ApiURL._forgotPassword, formdata);
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const changePassword = async (formdata) => {
  try {
    const response = await axios.post(ApiURL._changePWD, formdata);
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const deleteAccount = async (formdata) => {
  try {
    const response = await axios.post(ApiURL._deleteAccount, formdata);
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const clearNotifications = async () => {
  try {
    const response = await axios.post(ApiURL._clearAllNotifications);
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const listNotifications = async (data) => {
  try {
    const response = await axios.post(ApiURL._listNotifications, data);
    const setup = response.data.data.list.map((el) => {
      return {
        message: el.message,
        created_at: el.created_at,
        notification_id: el.notification_id,
        notification_type: el.notification_type,
        gym_id: el.notification_data.gym_id,
        read_at: el.read_at,
      };
    });
    return { data: setup, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};
export const readNotification = async (id) => {
  try {
    const response = await axios.post(ApiURL._readNotification, {
      notification_id: id,
    });
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const linkGym = async (formdata) => {
  try {
    const response = await axios.post(ApiURL._linkGym, formdata);
    const updatedData = setAccessTokenRespone(response.data.data);

    return { data: updatedData, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const updateGymWaiver = async (gym_id, isAccepted) => {
  try {
    const response = await axios.post(ApiURL._updateGymWaiver, {
      gym_id: gym_id,
      is_waiver_accepted: isAccepted,
    });
    const updatedData = setAccessTokenRespone(response.data.data);

    return { data: updatedData, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const gymInfo = async (formdata) => {
  try {
    const response = await axios.post(ApiURL._gymInfo, formdata);
    if (response.data.data.is_location_enabled) {
      const response1 = await axios.post(ApiURL._gymLocationList, {
        gym_id: response.data.data.gym_id,
      });
      const updatedData = response1.data.data.location_list.map((el) =>
        setLocation(el)
      );
      response.data.data.location_list = updatedData || [];
    }
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};
export const gymLocationList = async (formdata) => {
  try {
    const response = await axios.post(ApiURL._gymLocationList, formdata);
    const updatedData = response.data.data.location_list.map((el) =>
      setLocation(el)
    );
    return { data: updatedData, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const updateGymLocations = async (gymID, selectedLocationIDs) => {
  const data = { gym_id: gymID, selected_location_ids: selectedLocationIDs };
  try {
    const response = await axios.post(ApiURL._updateGymLocations, data);
    const updatedData = setAccessTokenRespone(response.data.data);
    return { data: updatedData, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const updateDefaultGym = async (gymID) => {
  try {
    const response = await axios.post(ApiURL._updateDefaultGym, {
      gym_id: gymID,
    });
    const updatedData = setAccessTokenRespone(response.data.data);
    return { data: updatedData, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const resendVerifyEmail = async () => {
  try {
    const response = await axios.post(ApiURL._resendVerifyEmail);
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const accessTokenApi = async (firebaseToken) => {
  try {
    const data = {
      device_type: "WEB",
      app_version: "0",
      timezone_offset: "0",
    };
    if (firebaseToken) {
      data["device_token"] = firebaseToken;
    }
    if (localStorage.getItem("setId")) {
      data["device_id"] = localStorage.getItem("setId");
    } else {
      return { status: false, logout: true };
    }
    const response = await axios.post(ApiURL._accessTokenLogin, data);
    const updatedData = setAccessTokenRespone(response.data.data);
    return { data: updatedData, status: true };
  } catch (err) {
    console.log(err);
    return {
      status: false,
      data: err.response,
      logout: err.response && err.response.data.statusCode === 401,
    };
  }
};

export const CarouselDataApi = async (URL, data) => {
  try {
    const response = await axios.post(URL, data);
    const list = response.data.data.list
      ? response.data.data.list.map((el) => SetCarouselDataApiResponse(el))
      : [];
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const CoachDataApi = async (URL, data) => {
  try {
    const response = await axios.post(URL, data);
    const list = response.data.data.list.map((el) =>
      SetCoachDataApiResponse(el)
    );
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const CoachProfileApi = async (URL, data) => {
  try {
    const response = await axios.post(URL, data);
    const list = SetCoachProfileApiResponse(response.data.data);
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const getActivitiesForCategory = async (URL, data) => {
  try {
    const response = await axios.post(URL, data);
    const list = SetCategoryProfileApiResponse(response.data.data);
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const listSections = async (gym_id) => {
  try {
    const response = await axios.post(ApiURL._listSections, { gym_id: gym_id });
    const list = response.data.data;
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const listDashboardActivities = async (data) => {
  try {
    const response = await axios.post(ApiURL._listDashboardActivities, data);
    const list = SetDashboardActivitiesApiResponse(response.data.data);
    return { list: list, status: true };
  } catch (err) {
    console.log(err);
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const LiveAndUpcomingApi = async (URL, data) => {
  try {
    const response = await axios.post(URL, data);
    const list = response.data.data.list.map((el) =>
      SetLiveAndUpcomingApiResponse(el)
    );
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const CategoriesApi = async (URL, data) => {
  try {
    const response = await axios.post(URL, data);
    const list = response.data.data.list.map((el) =>
      SetCategoriesApiResponse(el)
    );
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const ActivitySummaryApi = async (URL, data, isOndemand) => {
  try {
    const response = await axios.post(URL, data);
    const clubbedUsers =
      response.data.data[isOndemand ? "clubbedUsers" : "usersInActivity"];
    const list = SetActivitySummaryApiResponse(
      response.data.data.class_summary,
      clubbedUsers || [],
      response.data.data.user_summary
    );
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const ActivityInfoApi = async (URL, data, isOndemand) => {
  try {
    const response = await axios.post(URL, data);
    const responseData = isOndemand
      ? response.data.data.activityInfo
      : response.data.data.list[0];
    const list = SetActivityInfoApiResponse(responseData);
    list.gymLinkStatus = !isOndemand
      ? response.data.data.gymLinkRequested.linked_status
      : null;
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const ScheduleActivityApi = async (URL, data) => {
  try {
    const response = await axios.post(URL, data);
    // const list = SetActivityInfoApiResponse(response.data.data.list[0]);
    return { list: response, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};
export const cancelBookedActivity = async (activityID) => {
  try {
    const response = await axios.post(ApiURL._cancelBookedActivity, {
      activity_id: activityID,
      is_penalty_checked: false,
    });
    // const list = SetActivityInfoApiResponse(response.data.data.list[0]);
    return { list: response, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

// export const getCoach = async (data) => {
//     try {
//         const response = await axios.post(ApiURL._getCoach, data);
//         return response.data.data.map(el => (setCoach(el))).sort(sortData);
//     }
//     catch (err) {

//         return err.response ? err.response.data : 'Try Again'
//     }
// }

// export const getRoom = async (data) => {
//     try {
//         const response = await axios.post(ApiURL._getRooms, data);
//         const list = response.data.data.rooms.map(el => (setRoom(el)));
//         return { list: list, status: true };
//     }
//     catch (err) {
//         return { list: err.response ? err.response.data : 'Try Again', status: false };
//     }
// }

export const CheckGymStatus = (res) => {
  let text = null;
  let gym = {};
  const arr = [
    { status: 0, text: "pending" },
    { status: 2, text: "rejected" },
    { status: 3, text: "inactive" },
    { status: 4, text: "invite" },
  ];
  arr.forEach(async (el) => {
    const temp = res.gymsAdded.filter((el1) => el1.linked_status === el.status);
    if (temp.length && text === null) {
      text = el.text;
      gym = temp[0];
    }
  });
  return { text: text, gym: gym, role: res.roles };
};

export const ListMyActivitiesApi = async (URL, data) => {
  try {
    const response = await axios.post(URL, data);
    const list = response.data.data.list.map((el) =>
      SetListMyActivitiesApiRespnse(el)
    );
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const ListUpcomingActivitiesDates = async (URL, data) => {
  try {
    const response = await axios.post(URL, data);
    const list = response.data.data.list.map((el) => el.start_datetime || "-");
    return { list: list, status: true };
  } catch (err) {
    return {
      list: err.response ? err.response.data : "Try Again",
      status: false,
    };
  }
};

export const AppVersions = async () => {
  try {
    const response = await axios.post(ApiURL._appVersions);
    return { data: response.data.data, status: true };
  } catch (err) {
    return {
      data: err.response ? err.response.data : "Try again",
      status: false,
    };
  }
};
